import React from "react"
import {Button} from "@mui/material"
import {ButtonText, Container, Image} from "./component"
import {CategoryLink} from "../../models/secondary-nav"
import connect from "./connect"
import {MISSION_BLOCK_DATA_GA, VISITED_PAGES} from "../../config/constants"
import urls from "../../config/urls"
import {setDepartment} from "../../utils/setDepartment"

type MissionsCTAProps = CategoryLink & {
    url: string
    department: string
    textAlignment: string
    text: {arrowIconUrlAltText: string}
    rememberSelectedDepartment: boolean
}

const onClick = (target: string, department: string, rememberSelectedDepartment: boolean): void => {
    localStorage.removeItem(VISITED_PAGES)
    setDepartment(target, department, rememberSelectedDepartment)
}

export const MissionsCTA = ({
    title,
    target,
    url,
    department,
    text,
    textAlignment,
    rememberSelectedDepartment,
}: MissionsCTAProps) => {
    return (
        <Container data-testid="missions-cta" onClick={() => onClick(target, department, rememberSelectedDepartment)}>
            {/* Stays as a MUI button rather than UxCTA due to the latter not supporting the icon */}
            <Button
                href={`${url}${target}`}
                data-ga-v1={MISSION_BLOCK_DATA_GA}
                data-ga-v2={department}
                data-ga-v3={title}
            >
                <ButtonText data-testid="missions-cta-buttonText">{title}</ButtonText>
                <Image alignment={textAlignment} alt={text.arrowIconUrlAltText} src={urls.arrowIconUrl} />
            </Button>
        </Container>
    )
}

export default connect(MissionsCTA)
